export class GlobalVars {
    public static SERVER_ENDPOINT = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8000'
}
